/* Vivida CRO preview — annotate lazy Swatch King colour chips and preserve colour context with clean display titles. */
(() => {
  const selector = [
    '.Product__Info ul.swatch-view.swatch-view-image > li.swatch-view-item',
    '.Product__Info ul.swatch-view.swatch-view-custom-image > li.swatch-view-item'
  ].join(',');

  const attributeNames = [
    'orig-value',
    'data-value',
    'data-option-value',
    'data-tooltip',
    'data-title',
    'title',
    'aria-label'
  ];

  const cleanLabel = (raw) => {
    if (!raw) return '';
    let value = String(raw).replace(/\s+/g, ' ').trim();
    if (!value || value.length > 90 || /^https?:/i.test(value) || /^#[0-9a-f]{3,8}$/i.test(value)) return '';
    if (/^(colour|color|swatch|select)$/i.test(value)) return '';
    if (value.includes(' - ')) value = value.split(' - ').pop().trim();
    return value;
  };

  const readAttributes = (element) => {
    if (!element) return '';
    for (const name of attributeNames) {
      const value = cleanLabel(element.getAttribute && element.getAttribute(name));
      if (value) return value;
    }
    return '';
  };

  const findLabel = (item) => {
    let label = readAttributes(item);
    if (label) return label;

    const descendants = item.querySelectorAll('[orig-value], [data-value], [data-option-value], [data-tooltip], [data-title], [title], [aria-label]');
    for (const element of descendants) {
      label = readAttributes(element);
      if (label) return label;
    }

    const input = item.querySelector('input[value]');
    label = cleanLabel(input && input.value);
    if (label) return label;

    const image = item.querySelector('img[alt], .star-set-image[alt]');
    label = cleanLabel(image && image.getAttribute('alt'));
    if (label) return label;

    return '';
  };

  const annotate = () => {
    document.querySelectorAll(selector).forEach((item) => {
      const label = findLabel(item);
      if (!label) return;
      item.setAttribute('data-vivida-colour-label', label);
      if (!item.getAttribute('title')) item.setAttribute('title', label);
    });
  };

  const getProductData = () => {
    const productJson = document.querySelector('[data-product-json]');
    if (!productJson) return null;
    try {
      const parsed = JSON.parse(productJson.textContent);
      return parsed && parsed.product ? parsed.product : null;
    } catch (error) {
      return null;
    }
  };

  const getDisplayDescriptor = () => {
    const product = getProductData();
    const heading = document.querySelector('h1.ProductMeta__Title');
    if (!product || !heading || !product.title) return '';

    const rawTitle = String(product.title).replace(/\s+/g, ' ').trim();
    const displayTitle = String(heading.textContent || '').replace(/\s+/g, ' ').trim();
    if (!rawTitle || !displayTitle || rawTitle === displayTitle) return '';

    const separators = [' - ', ' – '];
    for (const separator of separators) {
      const index = rawTitle.indexOf(separator);
      if (index > -1) {
        return rawTitle.slice(index + separator.length).trim();
      }
    }
    return '';
  };

  const directChildWithin = (element, ancestor) => {
    let current = element;
    while (current && current.parentElement && current.parentElement !== ancestor) {
      current = current.parentElement;
    }
    return current && current.parentElement === ancestor ? current : null;
  };

  const ensurePdpColourLabel = () => {
    /* Product-specific liquid already supplies this on some families; never duplicate it. */
    if (document.querySelector('.VividaProductColourLabel')) return;

    const descriptor = getDisplayDescriptor();
    const variants = document.querySelector('.ProductForm__Variants');
    if (!descriptor || !variants) return;

    const label = document.createElement('div');
    label.className = 'VividaProductColourLabel VividaProductColourLabel--auto ProductForm__Label';
    label.innerHTML = 'Colour: <span class="ProductForm__SelectedValue"></span>';
    label.querySelector('.ProductForm__SelectedValue').textContent = descriptor;

    const swatch = variants.querySelector('.swatches-type-products, [class*="swatches-type-products"]');
    const swatchBlock = swatch ? directChildWithin(swatch, variants) : null;

    if (swatchBlock) {
      swatchBlock.insertAdjacentElement('afterend', label);
    } else {
      variants.insertBefore(label, variants.firstChild);
    }
  };

  const refine = () => {
    annotate();
    ensurePdpColourLabel();
  };

  let queued = false;
  const queueRefine = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      refine();
    });
  };

  const start = () => {
    if (!document.body.classList.contains('template-product')) return;
    refine();
    const productInfo = document.querySelector('.Product__Info') || document.body;
    new MutationObserver(queueRefine).observe(productInfo, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
